import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import * as styles from './PhotoLabels.css';
import { IPhotoLabel } from '../../../types/photoLabels';

interface IPhotoLabelsProps {
  labels: IPhotoLabel[];
  hasVideo: boolean;
}

export const PhotoLabels = ({ labels, hasVideo }: IPhotoLabelsProps) => {
  return (
    <div {...mergeStyles(styles['container'], hasVideo && styles['has-video'])}>
      {labels.map(({ text, color }) => (
        <div key={text} {...mergeStyles(styles['label'], styles[`${color}-label`])}>{text}</div>
      ))}
    </div>
  );
};
